// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import store from './store'
import VueAnalytics from 'vue-analytics';

import VueModal from 'vue-js-modal';
import 'font-awesome/css/font-awesome.css';
import './sass/main.sass';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Notification from '@/components/Shared/Notification/notifcation.vue'
import botMixin from './mixins/mixin.bot.js'
import VueTelInput from 'vue-tel-input'
import VueProgressBar from 'vue-progressbar'

import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)
const NotificationComponent = Vue.extend(Notification)
const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'left',
  inverse: false
}

library.add(faCoffee)
Vue.use(VueProgressBar, options)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('notification', require('vue-bulma-notifications'))
Vue.use(VueModal)
Vue.use(VueTelInput)
// Custom modal with Bulma :3
Vue.use({
  install(vue){
    vue.prototype.$hyModal={
      hide:function(id){
        document.getElementById(id).classList.remove('is-active');
      },
      show:function(id){
        document.getElementById(id).classList.add('is-active');
      }
    },
    vue.prototype.$notif = {
      show: function(propsData){        
        return new NotificationComponent({
          el: document.createElement('div'),
          propsData
        })
      }
    }
    // vue.prototype.$entityManage = {
    //   click: function(propDatass){        
    //     let instance = new EntityManageComponent({
    //       el: document.createElement('div'),
    //       propDatass
    //     })
    //     instance.$slots.default = ['Click me!']
    //     instance.$mount() // pass nothing
    //     console.log('test instanxe ', instance)
    //     return this.$refs.container.appendChild(instance.$el)
    //   }
    // }
  }
})



// 


import moment from 'moment'

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})


Vue.config.productionTip = false
Vue.use(VueAnalytics, {
  id: 'UA-159648158-1',
  router
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  mixin: [botMixin],
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js